import { ChipComponent, chipTemplate } from './Chip';
import styles from './Chip.styles.scss';
export const chipDefinition = {
    template: chipTemplate,
    styles,
};
export const chameleonChip = ChipComponent.compose(Object.assign({ baseName: 'chip' }, chipDefinition));
